import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../../components/AppAnimate";
import AppCard from "../../../../components/layouts/components/AppCard";
import ManageTransferPricing from "./ManageTransferPricing";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import AppCardLoaderFields from "../../../../components/Skeletons/AppCardLoaderFields";
import {shopTypesWithName} from "../../../../../config/Permissions";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import TextField from "@material-ui/core/TextField";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import {currencySymbol} from "../../../../../config/values";
import {withRouter} from "react-router-dom";
import {connect} from "trim-redux";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import Alert from "@material-ui/lab/Alert/Alert";
import LoadingButton from "../../../../components/elements/LoadingButton";
import validator from "validator";
import {checkMelliCode, updateRedux} from "../../../../../config/Security";
import Typography from "@material-ui/core/Typography/Typography";
import ViewTransferPricing from "./ViewTransferPricing";


class TransferPricingPage extends React.Component {
    classes = this.props.classes;
    state = {
        loading:true,
        transfer_type:'',
        transfer_fixed_price:'',
        transfer_free_limit:'',
        SubmitLoading:false,
        shop_id:null,
    }
    componentDidMount(){
        this.loadData();
    }
    async loadData(){
        let {user} = this.props;
        let shop_id = !!user.shops ? !!user.shops[0] ? user.shops[0].id : 0 : 0;
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.get(`${defaultVariabls.url}/shop/get/${shop_id}`, config)
            .then(response => {
                this.setState({
                    transfer_type: response.data.transfer_type,
                    transfer_fixed_price:response.data.transfer_fixed_price,
                    transfer_free_limit:response.data.transfer_free_limit,
                    shop_id:response.data.id,
                    loading:false,
                })
            })
            .catch(error => {
                console.log(error);
                this.props.enqueueSnackbar(Translate.dataFetchingError, {
                    variant: 'error',
                });
                this.setState({
                    loading:false
                })
            });
    }
    handleValidation(callback){
        let {transfer_type,transfer_fixed_price,transfer_free_limit} = this.state;
        let errors = {};
        let formIsValid = true;
        if(transfer_type === "fixed"){
            if(!transfer_fixed_price){
                formIsValid = false;
            }
        }
        if(transfer_type === "condition"){
            if(!transfer_free_limit){
                formIsValid = false;
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasErrorPleaseCheckThem, {
                variant: 'warning',
            });
            this.setState({
                SubmitLoading:false,
                errors
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        const {shop_id,transfer_type,transfer_fixed_price,transfer_free_limit} = this.state;
        let data = new FormData();

        data.append('transfer_type',transfer_type);
        data.append('transfer_fixed_price',transfer_fixed_price);
        data.append('transfer_free_limit',transfer_free_limit);
        data.append('id', shop_id);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/transfer_pricing/save`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.detailsSet, {
                    variant: 'success',
                });
                this.setState({
                    SubmitLoading:false
                });
            })
            .catch(error => {
                if(error.response.status === 403){
                    this.props.enqueueSnackbar(Translate.pleaseChooseWeightLimitsFirst, {
                        variant: 'warning',
                    });
                }else{
                    this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                        variant: 'error',
                    });
                }

                console.log(error.response);
                this.setState({
                    SubmitLoading:false
                });
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }

        });
    }
    render(){
        let {loading,transfer_type,transfer_fixed_price,transfer_free_limit,SubmitLoading,shop_id} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.transferPricing}>
                <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={Translate.transferPricing}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.transferPricing}/>
                            }>
                            {
                                loading ? <AppCardLoaderFields/> :
                                    <Grid container spacing={2} justifyContent="center">
                                        <Grid item xs={12} lg={11}>
                                            <Alert severity="info">
                                                <AlertTitle>{Translate.transferPricingTitle}</AlertTitle>
                                                <strong>{Translate.deaSupplier}</strong> {Translate.transferPricingTitleDesc}
                                            </Alert>
                                        </Grid>
                                        <Grid item xs={12} lg={11}>
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                value={transfer_type}
                                                fullWidth
                                                select
                                                label={Translate.transfer_type_definition}
                                                onChange={(e) => this.setState({
                                                    transfer_type: e.target.value
                                                }) }
                                            >
                                                <MenuItem value="free">
                                                    {Translate.free_transfer_type}
                                                </MenuItem>
                                                {/*<MenuItem value="fixed">
                                                    {Translate.fixed_transfer_type}
                                                </MenuItem>*/}
                                                <MenuItem value="condition">
                                                    {Translate.condition_transfer_type}
                                                </MenuItem>
                                                <MenuItem value="weight">
                                                    {Translate.weight_transfer_type}
                                                </MenuItem>
                                            </TextField>
                                        </Grid>
                                        {
                                            transfer_type === "fixed" &&
                                            <Grid item xs={12} lg={11}>
                                                <CurrencyTextField
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    currencySymbol={currencySymbol}
                                                    decimalPlaces={0}
                                                    value={transfer_fixed_price}
                                                    id="price"
                                                    label={Translate.transfer_fixed_price}
                                                    name="price"
                                                    onChange={(e) => this.setState({
                                                        transfer_fixed_price: e.target.value.replace(/,/ig, '')
                                                        })
                                                    }
                                                />
                                            </Grid>
                                        }
                                        {
                                            transfer_type === "condition" &&
                                            <Grid item xs={12} lg={11}>
                                                <CurrencyTextField
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    currencySymbol={currencySymbol}
                                                    decimalPlaces={0}
                                                    value={transfer_free_limit}
                                                    label={Translate.transfer_free_limit}
                                                    onChange={(e) => this.setState({
                                                        transfer_free_limit: e.target.value.replace(/,/ig, '')
                                                    })
                                                    }
                                                />
                                                <Typography style={{marginTop:10,marginBottom:15}}>{Translate.transfer_free_limit_desc}</Typography>
                                                <Typography style={{marginTop:10,marginBottom:15}}>{Translate.transfer_free_limit_fixed_desc}</Typography>
                                            </Grid>
                                        }
                                        {
                                            <Grid item xs={12} lg={11}>
                                                <LoadingButton
                                                    variant="contained"
                                                    color="primary"
                                                    onClick = {this.handleSubmit.bind(this)}
                                                    loading = {SubmitLoading}
                                                >
                                                    {Translate.save}
                                                </LoadingButton>
                                            </Grid>
                                        }
                                    </Grid>
                            }
                        </AppCard>
                    </Grid>
                    {
                        (transfer_type === "weight" || transfer_type === "condition") &&
                        <Grid item xs={12}>
                            <AppCard>
                                <Grid container spaicng={2} justifyContent="center">
                                    <Grid item xs={12} lg={11}>
                                        <ViewTransferPricing/>
                                    </Grid>
                                </Grid>
                            </AppCard>
                        </Grid>
                    }

                </Grid>
            </AppAnimate>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,

});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(TransferPricingPage))));
